var _polygon, _g, _circle, _circle2, _circle3, _path, _path2, _path3, _g2, _g3, _g4, _g5, _path4, _path5, _path6, _g6, _g7, _path7, _path8, _path9, _path10, _g8, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDigmenthaDeliver = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220px",
    height: "513px",
    viewBox: "0 0 220 513",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-538.000000, -1076.000000)",
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 757.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(532.000000, 319.000000)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#223449",
    fillRule: "nonzero",
    points: "18.25 86.06 6.56 78.07 59.97 0 67.47 1.58 71.66 7.99"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    stroke: "#E63A27"
  }, /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(130.010279, 148.769866) rotate(-38.700000) translate(-130.010279, -148.769866) ",
    cx: 130.010279,
    cy: 148.769866,
    rx: 14.9,
    ry: 12.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(83.695465, 90.944424) rotate(-38.700000) translate(-83.695465, -90.944424) ",
    cx: 83.6954648,
    cy: 90.9444236,
    rx: 26.73,
    ry: 22.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(100.082932, 111.396498) rotate(-38.700000) translate(-100.082932, -111.396498) ",
    cx: 100.082932,
    cy: 111.396498,
    rx: 22.74,
    ry: 19.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01267296,
    transform: "translate(117.814500, 128.088400) rotate(-38.927544) translate(-117.814500, -128.088400) ",
    cx: 117.8145,
    cy: 128.0884,
    rx: 17.616499,
    ry: 15.1199092
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(145.978587, 168.680914) rotate(-38.700000) translate(-145.978587, -168.680914) ",
    cx: 145.978587,
    cy: 168.680914,
    rx: 6.4,
    ry: 5.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(159.528468, 185.602207) rotate(-38.700000) translate(-159.528468, -185.602207) ",
    cx: 159.528468,
    cy: 185.602207,
    rx: 3.36,
    ry: 2.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(65.957757, 68.807499) rotate(-38.700000) translate(-65.957757, -68.807499) ",
    cx: 65.957757,
    cy: 68.8074991,
    rx: 31.9,
    ry: 27.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.01,
    transform: "translate(50.288666, 49.239833) rotate(-38.700000) translate(-50.288666, -49.239833) ",
    cx: 50.2886661,
    cy: 49.2398328,
    rx: 37.52,
    ry: 32.22
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C0272D",
    opacity: 0.5,
    transform: "translate(167.438891, 201.147116) rotate(-3.540000) translate(-167.438891, -201.147116) ",
    cx: 167.438891,
    cy: 201.147116,
    r: 39.87
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C0272D",
    opacity: 0.25,
    transform: "translate(167.438891, 201.147116) rotate(-3.540000) translate(-167.438891, -201.147116) ",
    cx: 167.438891,
    cy: 201.147116,
    r: 57.64
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C0272D",
    opacity: 0.75,
    transform: "translate(167.324282, 200.904366) rotate(-3.540000) translate(-167.324282, -200.904366) ",
    cx: 167.324282,
    cy: 200.904366,
    r: 22.02
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 0,
    width: 121,
    height: 154,
    xlinkHref: "data:image/png;base64,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"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.39,1.36 C32.16,1.36 9.04,21.36 6.8,46.8 C6.8,46.8 6.64,46.8 6.64,46.8 L6.8,46.8 C6.8,46.93 6.8,47.05 6.8,47.18 L6.68,47.18 L6.68,47.26 L10.84,98.34 C11.43,105.6 11.74,109.27 16.33,115.4 C24.62,126.47 38.77,134.51 50.68,140.84 C57.2406922,143.732968 64.762707,143.475239 71.11,140.14 C73.59,139.31 78.26,136.09 80.37,134.9 C83.15,133.32 85.64,130.9 88.23,129.03 C93.65,125.16 91.72,125.83 99.01,119.6 C108.12,111.8 111.07,99.49 111.72,88.6 L112.86,69.77 C113.31,62.28 114.22,54.65 114.22,47.14 L114.22,46.87 C114.22,46.87 114.22,46.8 114.22,46.73 C111.95,21.37 88.62,1.36 60.39,1.36 Z",
    id: "Path",
    fill: "#EEAB89",
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.38,282.94 C139.38,282.94 150.96,329.04 145.24,339.18 C145.24,339.18 145.89,303.68 136.58,282.94 L139.38,282.94 Z",
    id: "Path",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.61,282.94 C37.61,282.94 26.03,329.04 31.75,339.18 C31.75,339.18 31.1,303.68 40.41,282.94 L37.61,282.94 Z",
    id: "Path",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.000000, 218.000000)",
    fill: "#EEAB89",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25,45.5 C0.25,45.5 9.46,41 3.69,3.77 C3.69,3.77 13.25,31.05 5.59,46.54 L0.25,45.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.28,
    cy: 3.34,
    r: 3.03
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.000000, 219.000000)",
    fill: "#EEAB89",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18,45.95 C9.18,45.95 -0.03,41.45 5.74,4.22 C5.74,4.22 -3.82,31.5 3.84,46.99 L9.18,45.95 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.15,
    cy: 3.82,
    r: 3.03
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    x: 0,
    y: 0,
    width: 110,
    height: 107,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.31,54.56 C45.79,58.91 51.44,62.2 55.8,61.72 C60.16,61.24 64.98,57.12 64.49,52.77 C64,48.42 58.36,45.13 54,45.61 C49.64,46.09 44.83,50.21 45.31,54.56 Z",
    id: "Path",
    fill: "#C0272D",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9,11.2 C13.7038597,11.5193093 13.7491413,11.9309606 14.01,12.2 C13.7756617,11.9190794 13.7323285,11.5251416 13.9,11.2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9,11.2 C13.7038597,11.5193093 13.7491413,11.9309606 14.01,12.2 C13.7756617,11.9190794 13.7323285,11.5251416 13.9,11.2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.59 10.72 14.59 10.72 14.45 10.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.59 10.72 14.59 10.72 14.45 10.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13,1.12 C2.88667032,2.93438208 0.331731053,7.31311742 0.84,11.9 L7.11,11.2 L15.11,10.31 L21.38,9.61 C20.8655452,5.02372356 17.4088403,1.31517888 12.87,0.48 C11.8984592,0.315470956 10.9082702,0.291895027 9.93,0.41 C8.95711286,0.447061891 8.00299539,0.688998819 7.13,1.12 Z M11.67,2.88 C12.0403575,2.44544447 12.5703427,2.17864923 13.14,2.14 C14.5277736,2.08842625 15.8830506,2.56760071 16.93,3.48 C18.86,5.03 19.64,7.26 18.67,8.48 C18.2996425,8.91455553 17.7696573,9.18135077 17.2,9.22 C15.8122264,9.27157375 14.4569494,8.79239929 13.41,7.88 C11.48,6.34 10.7,4.1 11.67,2.88 Z",
    id: "Shape",
    fill: "#C0272D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.67,2.88 C12.0403575,2.44544447 12.5703427,2.17864923 13.14,2.14 C14.5277736,2.08842625 15.8830506,2.56760071 16.93,3.48 C18.86,5.03 19.64,7.26 18.67,8.48 C18.2996425,8.91455553 17.7696573,9.18135077 17.2,9.22 C15.8122264,9.27157375 14.4569494,8.79239929 13.41,7.88 C11.48,6.34 10.7,4.1 11.67,2.88 Z",
    id: "Path",
    fill: "#C0272D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,9.22 C17.7696573,9.18135077 18.2996425,8.91455553 18.67,8.48 C19.67,7.27 18.86,5.03 16.93,3.48 C15.8830506,2.56760071 14.5277736,2.08842625 13.14,2.14 C12.5703427,2.17864923 12.0403575,2.44544447 11.67,2.88 C10.67,4.09 11.48,6.33 13.41,7.88 C14.4569494,8.79239929 15.8122264,9.27157375 17.2,9.22 Z",
    id: "Path",
    fill: "#C63D42",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,9.22 C17.7696573,9.18135077 18.2996425,8.91455553 18.67,8.48 C19.67,7.27 18.86,5.03 16.93,3.48 C15.8830506,2.56760071 14.5277736,2.08842625 13.14,2.14 C12.5703427,2.17864923 12.0403575,2.44544447 11.67,2.88 C10.67,4.09 11.48,6.33 13.41,7.88 C14.4569494,8.79239929 15.8122264,9.27157375 17.2,9.22 Z",
    id: "Path",
    fill: "#C63D42",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C0272D",
    fillRule: "nonzero",
    transform: "translate(20.680488, 113.893403) rotate(-6.350000) translate(-20.680488, -113.893403) ",
    x: 20.0504877,
    y: 44.6584029,
    width: 1.26,
    height: 138.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C0272D",
    fillRule: "nonzero",
    transform: "translate(20.680488, 113.893403) rotate(-6.350000) translate(-20.680488, -113.893403) ",
    x: 20.0504877,
    y: 44.6584029,
    width: 1.26,
    height: 138.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C0272D",
    fillRule: "nonzero",
    transform: "translate(24.432134, 113.481162) rotate(-6.350000) translate(-24.432134, -113.481162) ",
    x: 23.8021341,
    y: 44.2461621,
    width: 1.26,
    height: 138.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C0272D",
    fillRule: "nonzero",
    transform: "translate(24.432134, 113.481162) rotate(-6.350000) translate(-24.432134, -113.481162) ",
    x: 23.8021341,
    y: 44.2461621,
    width: 1.26,
    height: 138.47
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    points: "31.01 200.66 29 182.59 27.75 182.73 29.76 200.8 31 200.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    points: "31.01 200.66 29 182.59 27.75 182.73 29.76 200.8 31 200.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    points: "33.51 200.39 33.52 200.38 34.76 200.25 32.75 182.17 31.5 182.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    points: "33.51 200.39 33.52 200.38 34.76 200.25 32.75 182.17 31.5 182.31"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    transform: "translate(15.512690, 33.334433) rotate(-6.350000) translate(-15.512690, -33.334433) ",
    x: 14.8826896,
    y: 21.9344332,
    width: 1.26,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    transform: "translate(15.512690, 33.334433) rotate(-6.350000) translate(-15.512690, -33.334433) ",
    x: 14.8826896,
    y: 21.9344332,
    width: 1.26,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    transform: "translate(11.762149, 33.756613) rotate(-6.350000) translate(-11.762149, -33.756613) ",
    x: 11.1321493,
    y: 22.3566127,
    width: 1.26,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    transform: "translate(11.762149, 33.756613) rotate(-6.350000) translate(-11.762149, -33.756613) ",
    x: 11.1321493,
    y: 22.3566127,
    width: 1.26,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C63D42",
    fillRule: "nonzero",
    transform: "translate(22.550758, 113.677313) rotate(-6.350000) translate(-22.550758, -113.677313) ",
    x: 21.2957579,
    y: 44.4423131,
    width: 2.51,
    height: 138.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C63D42",
    fillRule: "nonzero",
    transform: "translate(22.550758, 113.677313) rotate(-6.350000) translate(-22.550758, -113.677313) ",
    x: 21.2957579,
    y: 44.4423131,
    width: 2.51,
    height: 138.47
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB64F",
    fillRule: "nonzero",
    transform: "translate(31.217905, 191.530773) rotate(-6.350000) translate(-31.217905, -191.530773) ",
    x: 29.9629054,
    y: 182.435773,
    width: 2.51,
    height: 18.19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB64F",
    fillRule: "nonzero",
    transform: "translate(31.217905, 191.530773) rotate(-6.350000) translate(-31.217905, -191.530773) ",
    x: 29.9629054,
    y: 182.435773,
    width: 2.51,
    height: 18.19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB64F",
    fillRule: "nonzero",
    transform: "translate(13.642419, 33.540523) rotate(-6.350000) translate(-13.642419, -33.540523) ",
    x: 12.3874194,
    y: 22.140523,
    width: 2.51,
    height: 22.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FAB64F",
    fillRule: "nonzero",
    transform: "translate(13.642419, 33.540523) rotate(-6.350000) translate(-13.642419, -33.540523) ",
    x: 12.3874194,
    y: 22.140523,
    width: 2.51,
    height: 22.8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F69220",
    fillRule: "nonzero",
    points: "10.9 20.06 10.93 20.06 7.99 13.72 1.17 14.48 1.13 14.49 8.49 20.33 9.07 20.26 9.32 22.51 9.88 22.45 9.9 22.45 11.15 22.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F69220",
    fillRule: "nonzero",
    points: "10.9 20.06 10.93 20.06 7.99 13.72 1.17 14.48 1.13 14.49 8.49 20.33 9.07 20.26 9.32 22.51 9.88 22.45 9.9 22.45 11.15 22.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F69220",
    fillRule: "nonzero",
    points: "13.38 19.78 13.4 19.78 13.65 22.03 14.9 21.89 14.93 21.89 15.48 21.83 15.23 19.58 15.82 19.51 21.72 12.19 21.66 12.2 14.86 12.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F69220",
    fillRule: "nonzero",
    points: "13.38 19.78 13.4 19.78 13.65 22.03 14.9 21.89 14.93 21.89 15.48 21.83 15.23 19.58 15.82 19.51 21.72 12.19 21.66 12.2 14.86 12.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F89E36",
    fillRule: "nonzero",
    points: "13.4 19.78 13.38 19.78 14.86 12.96 14.83 12.96 8 13.72 7.99 13.72 10.93 20.06 10.9 20.06 11.15 22.31 13.65 22.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F89E36",
    fillRule: "nonzero",
    points: "13.4 19.78 13.38 19.78 14.86 12.96 14.83 12.96 8 13.72 7.99 13.72 10.93 20.06 10.9 20.06 11.15 22.31 13.65 22.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,201.5 L29.79,202.08 C29.6858735,202.186752 29.5889914,202.300338 29.5,202.42 C28.4457337,203.736718 28.2885493,205.558893 29.1017544,207.036702 C29.9149595,208.514512 31.538373,209.356864 33.2148699,209.170904 C34.8913669,208.984945 36.2907196,207.807303 36.7603001,206.187205 C37.2298807,204.567107 36.6771935,202.823672 35.36,201.77 C35.2462445,201.671962 35.1259683,201.581755 35,201.5 Z M35.66,207.37 C35.1760795,208.014593 34.4573753,208.442222 33.66,208.56 C33.2564222,208.621405 32.8451775,208.51679 32.52,208.27 C31.72,207.63 31.8,206.19 32.71,205.06 C33.1939205,204.415407 33.9126247,203.987778 34.71,203.87 C35.1135778,203.808595 35.5248225,203.91321 35.85,204.16 C36.66,204.78 36.57,206.22 35.67,207.35 L35.66,207.37 Z",
    id: "Shape",
    fill: "#FAAF3A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.77,205.03 C31.86,206.16 31.77,207.6 32.58,208.24 C32.9051775,208.48679 33.3164222,208.591405 33.72,208.53 C34.5173753,208.412222 35.2360795,207.984593 35.72,207.34 C36.63,206.21 36.72,204.77 35.91,204.13 C35.5848225,203.88321 35.1735778,203.778595 34.77,203.84 C33.9726247,203.957778 33.2539205,204.385407 32.77,205.03 Z",
    id: "Path",
    fill: "#FAB64F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,13.72 L8,13.28 C7.66091594,13.352174 7.3102794,13.2254123 7.09573664,12.9530917 C6.88119389,12.6807712 6.84001988,12.3102051 6.98955219,11.9974317 C7.13908451,11.6846584 7.4533432,11.4840194 7.8,11.48 L7.8,11.05 L2.45,11.65 L0.98,11.81 L1.28,14.48 L8.1,13.72 L8,13.72 Z M4.3,11.86 L4.5,13.66 L4.3,11.86 Z",
    id: "Shape",
    fill: "#FAAF3A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    points: "7.69 11.06 2.34 11.65 0.88 11.82 1.17 14.48 7.99 13.72 8 13.72 7.95 13.28 7.75 11.48 7.71 11.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FAAF3A",
    fillRule: "nonzero",
    points: "19.91 9.7 14.56 10.29 14.54 10.29 14.58 10.72 14.78 12.52 14.83 12.96 14.86 12.96 21.66 12.2 21.37 9.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71,11.05 L7.71,11.48 L7.91,13.28 L7.91,13.72 L14.74,12.96 L14.74,12.52 L14.54,10.72 L14.54,10.29 L7.71,11.05 Z M11.38,12.9 C11.0135889,12.9425275 10.6577508,12.7596544 10.4790296,12.4369712 C10.3003084,12.1142881 10.3340627,11.7156353 10.5644945,11.4275956 C10.7949263,11.1395559 11.1764463,11.0191157 11.5304906,11.1226449 C11.8845349,11.2261742 12.1410585,11.5331905 12.18,11.9 C12.2324513,12.399813 11.8698099,12.8475185 11.37,12.9 L11.38,12.9 Z",
    id: "Shape",
    fill: "#FAB64F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.37,12.9 C11.0035889,12.9425275 10.6477508,12.7596544 10.4690296,12.4369712 C10.2903084,12.1142881 10.3240627,11.7156353 10.5544945,11.4275956 C10.7849263,11.1395559 11.1664463,11.0191157 11.5204906,11.1226449 C11.8745349,11.2261742 12.1310585,11.5331905 12.17,11.9 C12.2226903,12.3963174 11.8657783,12.8424575 11.37,12.9 Z",
    id: "Path",
    fill: "#FAB64F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F69220",
    fillRule: "nonzero",
    points: "35.15 201.47 35.01 200.22 34.79 200.25 34.76 200.25 33.52 200.38 33.51 200.39 31.01 200.66 31 200.67 29.76 200.8 29.74 200.81 29.43 200.84 29.57 202.09 29.8 202.07 35.01 201.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F69220",
    fillRule: "nonzero",
    points: "35.15 201.47 35.01 200.22 34.79 200.25 34.76 200.25 33.52 200.38 33.51 200.39 31.01 200.66 31 200.67 29.76 200.8 29.74 200.81 29.43 200.84 29.57 202.09 29.8 202.07 35.01 201.49"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 301.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5A5A5",
    points: "127.95 64.16 117.82 69.75 115.54 78.35 141.79 70.61 157.66 61.06 169.7 20.41 163.79 22.05 147.82 49.75 152.29 54.8 143.57 53.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5A5A5",
    points: "111.06 170.42 115.82 150.24 109.16 130.21 50.47 130.21 43.82 150.24 48.75 170.42 63.33 170.42 74.59 170.42 80.03 170.42 92 170.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5A5A5",
    points: "43.14 78.23 39.44 69.34 21.01 75.97 0.71 87.53 9.28 128.89 14.26 125.31 13.85 94.75 7.92 91.56 20.87 91.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#848484",
    transform: "translate(16.104867, 136.384277) rotate(-29.820000) translate(-16.104867, -136.384277) ",
    cx: 16.1048665,
    cy: 136.384277,
    rx: 7.28,
    ry: 11.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#848484",
    transform: "translate(170.526332, 14.541071) rotate(-62.940000) translate(-170.526332, -14.541071) ",
    cx: 170.526332,
    cy: 14.541071,
    rx: 11.59,
    ry: 7.28
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5A5A5",
    points: "111.89 166.62 84.3 166.62 93.56 205.5 103.32 205.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5A5A5",
    points: "75.51 166.62 47.91 166.62 56.49 205.5 66.25 205.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29,98.99 L116.89,79.06 L120,69.31 L78,71.06 L39.63,69.31 L43.33,80.91 L47.82,98.91 L49.17,99.27 L54.85,117.06 C54.85,117.06 50,130.26 50.47,130.26 L109.17,130.26 L104.79,117.06 L110.47,99.26 L111.29,98.99 Z",
    id: "Path",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 69.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.26,29.86 L57.91,30.22 L52.23,48.01 C52.23,48.01 57.08,61.21 56.61,61.21 L63.26,81.21 L58.33,101.33 L54.77,117.33 L54.1,114.17 L55.43,101.37 L60.36,81.22 L52.9,61.13 C53.36,61.13 48.52,47.94 48.52,47.94 L54.2,30.15 L55.55,29.79 L60.04,11.79 L63.69,0.5 L67.45,0.33 L63.75,11.93 L59.26,29.86 Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF262A",
    points: "62.49 65.55 55.43 82.85 63.17 99.8 62.38 103.18 52.67 83.11 61.51 62.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF262A",
    points: "56.67 48.01 42.14 53.64 36.01 83.11 40.98 51.13 57.99 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF262A",
    points: "6.96 48.01 21.49 53.64 27.62 83.11 22.65 51.13 5.65 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF262A",
    points: "0.59 66.54 7.46 82.85 0.08 99.65 0.81 102.96 10.23 83.11 1.69 63.22"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A5A5A5",
    points: "51.69 69.86 79 67.5 110.17 69.86 102 75.5 54 75.5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36,297.67 C36,297.67 48.63,233.85 87.41,250.35 C87.41,250.35 124.67,233.35 141.28,297.88 L143.45,280.77 C143.45,280.77 138.88,227.61 88.45,235.36 C88.45,235.36 40.33,220.54 34.7,280.83 L36,297.67 Z",
    id: "Path",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87,353.5 C87,353.5 24,399.5 35,297.5 C35,297.5 42,248.5 70,243.5 C98,238.5 88,247.5 88,247.5 L87,353.5 Z",
    id: "Path",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.13,353.5 C87.13,353.5 153.13,399.5 141.65,297.5 C141.65,297.5 134.31,248.5 104.96,243.5 C75.61,238.5 86.09,247.5 86.09,247.5 L87.13,353.5 Z",
    id: "Path",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.000000, 235.000000)",
    fill: "#AFAFAF",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,118.5 C51,118.5 19,40.5 52,0.5 C52,0.5 7.10542736e-15,39.5 51,118.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,0.5 C52,0.5 -21,54.5 51,118.5 C51,118.5 -29,67.5 52,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.63,125.7 C37.63,125.7 8,105.5 10,76.5 C10,76.5 -2.79,108.19 23.1,128.85 C23.1,128.85 31.27,128.9 37.63,125.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,121.66 C46,121.66 6,91.5 13,53.5 C13,53.5 -1,94.83 46,121.66 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,0.5 C52,0.5 23,4.5 15,33.5 C15,33.5 16,0.5 52,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,53.5 C7,53.5 6,23.86 14,15.18 C14,15.18 -1,27.5 7,53.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,62.5 C5,62.5 -2,91.5 7,107.5 C7,107.5 -7,83.5 5,62.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,51.5 C25,51.5 24,79.5 31,86.5 C31,86.5 18,71.5 25,51.5 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.000000, 235.000000)",
    fill: "#AFAFAF",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14,118.5 C1.14,118.5 33.14,40.5 0.14,0.5 C0.14,0.5 52.14,39.5 1.14,118.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.14,0.5 C0.14,0.5 73.14,54.5 1.14,118.5 C1.14,118.5 81.14,67.5 0.14,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.51,125.7 C14.51,125.7 44.14,105.5 42.14,76.5 C42.14,76.5 54.93,108.19 29.04,128.85 C29,128.85 20.87,128.9 14.51,125.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16,121.66 C6.16,121.66 46.16,91.5 39.16,53.5 C39.14,53.5 53.17,94.83 6.16,121.66 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.14,0.5 C0.14,0.5 29.14,4.5 37.14,33.5 C37.14,33.5 36.14,0.5 0.14,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,53.5 C45.14,53.5 46.14,23.86 38.13998,15.18 C38.12,15.18 53.14,27.5 45.14,53.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.14,62.5 C47.14,62.5 54.14,91.5 45.14,107.5 C45.14,107.5 59.14,83.5 47.14,62.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14,51.5 C27.14,51.5 28.14,79.5 21.14,86.5 C21.14,86.5 34.14,71.5 27.14,51.5 Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88,353.5 C88,353.5 76,298.5 82,281.5 L88,353.5 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87,235.5 C87,235.5 91,268.5 90,281.5 C90,281.5 96,250.5 87,235.5 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82,272.5 C82,272.5 81,239.5 87,235.5 C87,235.5 75,247.5 82,272.5 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90,302.5 C90,302.5 93,344.5 88,353.5 L90,302.5 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.000000, 213.000000)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.52,16.23 C40.52,16.23 45.91,4.92 58.41,14.69 C58.41,14.69 46,0.93 40.52,16.23 Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.52,14.88 C40.52,14.88 45.91,3.57 58.41,13.34 C58.41,13.34 46,-0.42 40.52,14.88 Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,18.92 C18,18.92 12.61,7.61 0.11,17.38 C0.1,17.38 12.48,3.62 18,18.92 Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.91,12.88 C27.91,12.88 25.91,0.52 41.72,1.4 C41.72,1.4 23.71,-2.83 27.91,12.88 Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.41,15.96 L0,12.65 C0,12.65 2.5,7.52 4.09,7.2 C5.68,6.88 18.34,0.79 18.34,0.79 C18.34,0.79 34.98,1.11 36.5,2.07 C38.02,3.03 47.44,8.37 47.44,8.37 L47.44,14.56 L36.5,17.22 L31.93,21.92 C31.93,21.92 13.38,20.5 13.37,19.29 C13.36,18.08 13.41,15.96 13.41,15.96 Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF262A",
    points: "13.4 17.75 24.25 19.06 35.27 18.54 24.39 17.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF262A",
    points: "13.4 17.75 13 19.5 25 21.36 34.74 20.11 35.27 18.54"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64,230.5 C64,230.5 76,226.5 84,231.5 C84,231.5 77,222.5 82,218.5 L90.63,219.07 C90.63,219.07 93,231.5 98,231.5 C98,231.5 108.26,229.32 107.13,223.91 L111,226.5 C111,226.5 119,236.5 99,236.5 C79,236.5 80.66,235.87 80.66,235.87 L77,235.5 C77,235.5 64,233.5 64,230.5 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84,231.5 C84,231.5 75.8,227.82 77.4,221.16 C77.4,221.16 73.53,220.54 72.27,223.52 C72.27,223.5 75,230.5 84,231.5 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.24,219.6 C98.24,219.6 98.53,230.45 96.24,230.97 L95,231.5 C95,231.5 100,233.5 101,220.5 C101,220.5 100.48,218.7 98.24,219.6 Z",
    id: "Path",
    fill: "#AFAFAF",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDigmenthaDeliver, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/digmentha-deliver.4d67286d.svg";
export { ForwardRef as ReactComponent };